import Vue from 'vue'
import VueIntro from 'vue-introjs';

Vue.use(VueIntro);

import 'intro.js/introjs.css';
